import serviceDateTimeToIso from './service-date-time-to-iso';

function formatTimeUiLabel(dateTime, locales, timeFormatOptions) {
  const dateTimeIso = serviceDateTimeToIso(dateTime);
  const date = new Date(dateTimeIso);
  return date.toLocaleTimeString(locales, timeFormatOptions);
}

export default formatTimeUiLabel;
